<template>
  <div class="SelectExcitation">
    <div class="page-module">
      <div  class="pdf_box" element-loading-text="加载中" element-loading-background="rgba(0, 0, 0, 0.8)">
        <pdf v-for="item in pageCount" :key="item" :src="fullurl" :page="item"/>
      </div>
      <div class="btn">
        
        <el-button v-if="isdownloadresult == 0" class="down" @click="activePopu">下载报告</el-button>
        <el-button v-else @click="getReportUrl" class="down">下载报告</el-button>
      </div>
    </div>
    <!-- <div class="download_report_pop">
        <el-dialog :visible.sync="dialogVisible">
            <div class="pop_content_box">
                <img :src="require('@/common/images/gujingimgs/icon_other.png')" alt="">
                <p>您已成功获取企业估值报告<br />点击下方按钮进行下载</p>
                <el-button type="primary" @click="downloadPdf(pdfUrl)">点击下载报告</el-button>
            </div>
        </el-dialog>
    </div> -->
    <el-dialog width="500px" :visible.sync="dialogVisible" :before-close="closePopu" title="免费下载">
      <div class="right_div">
          <p class="p_tips">请填写以下信息，即可下载免费报告。</p>
          <div class="info_warp">
            <el-form :model="api" :rules="rules" label-width="80px" ref="refForm">
              <el-form-item label="联系人：" prop="linkman">
                <el-input v-model="api.linkman" placeholder="请填写联系人"></el-input>
              </el-form-item>
              <el-form-item label="联系电话：" prop="linktel">
                <el-input v-model="api.linktel" placeholder="请填写联系电话"></el-input>
              </el-form-item>
              <el-form-item label="职位：" prop="linkduty">
                <el-input v-model="api.linkduty" placeholder="请填写您的职位"></el-input>
              </el-form-item>
            </el-form>
              <!-- <input class="input" style="width:0;height:0;padding:0"/> -->
                  <!-- <div class="info_item_div" v-for="(item, index) in infoData" :key="index">
                      <span>{{item.title}}</span>
                      <el-input class="input" v-model="item.inputValue" :placeholder="item.placeholder"></el-input>
                  </div>
                  <input class="input" style="width:0;height:0;padding:0"/> -->
          </div>
          <el-button @click="getReport('refForm')" type="primary" round>下载报告</el-button>
          
        </div>
    </el-dialog>
  </div>
</template>

<script>

import {downloadSiReport, getReportUrl} from 'api/gujingApi'
import pdf from 'vue-pdf'
import {mapActions} from 'vuex'
export default {
  name: 'SelectExcitation',
  data () {
    var justLinkman = (rule, value, callball) => {
      if (!value) {
        return callball(new Error('联系人不能为空'))
      }
      callball()
    }
    var justLinktel = (rule, value, callball) => {
      if (!value) {
        return callball(new Error('联系电话不能为空'))
      } else {
        if (!(/^1[3456789]\d{9}$/.test(value))) {
          return callball(new Error('请填写正确的联系电话'))
        }
      }
      callball()
    }
    var justLinkduty = (rule, value, callball) => {
      if (!value) {
        return callball(new Error('职位不能为空'))
      }
      callball()
    }
    return {
      dialogVisible: false,
      pageCount: '', // pdf文件总页数
      fullurl: this.$route.query.fullurl,
      orderno: this.$route.query.orderno,
      api: {
        orderno: this.$route.query.orderno,
        companyname: "",
        linkman: '',
        linktel: '',
        linkduty: ''
      },
      isdownloadresult: this.$route.query.isdownloadresult? this.$route.query.isdownloadresult : 0,
      rules: {
        linkman: [
          {validator: justLinkman, trigger: 'blur'}
        ],
        linktel: [
          {validator: justLinktel, trigger: 'blur'}
        ],
        linkduty: [
          {validator: justLinkduty, trigger: 'blur'}
        ]
      }
    }
  },
  mounted () {
        this.setLoading(true)
        this.fullurl = pdf.createLoadingTask(this.fullurl)
        this.fullurl.then(pdf => {
            // console.log('pdf',pdf)
            this.setLoading(false)
            this.pageCount = pdf.numPages
            this.$nextTick(() => {
            })
        })
  },
  methods: {
    activePopu() {
      this.dialogVisible = true
    },
    closePopu() {
      this.dialogVisible = false
    },
    // 免费获取报告
    getReport(refForm) {
      this.$refs[refForm].validate((valid) => {
        if (valid) {
          this.setLoading(true)
          downloadSiReport({
                data: this.api,
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.isdownloadresult = 1
                    this.downloadPdf(data.data.sireporturl, data.data.companyname)
                },
                error: data => {
                    this.$message.error(data.msg)
                }
          })
        } else {
          return false
        }
      })

    },
    getReportUrl() {
      this.setLoading(true)
          getReportUrl({
                data: {orderno: this.orderno},
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.downloadPdf(data.data.sireporturl, data.data.companyname)
                },
                error: data => {
                    this.$message.error(data.msg)
                }
          })
    },
    // 下载报告
        downloadPdf(url, companyname) {
            this.setLoading(true)
            fetch(url).then(res => res.blob()).then(blob => {
                // console.log(blob)
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.style.display = 'none'
                // 使用获取到的blob对象创建的url
                const url = window.URL.createObjectURL(blob)
                a.href = url
                // 指定下载的文件名
                a.download = companyname + '公司股权激励方案'
                this.setLoading(false)
                this.dialogVisible = false
                a.click()
                document.body.removeChild(a)
                // 移除blob对象的url
                window.URL.revokeObjectURL(url)
            })
        },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
    pdf
  }
}
</script>

<style lang="scss" type="text/scss" >
.SelectExcitation {
//   margin-top: 80px;
  .btn {
    position: fixed;
    width: 1180px;
    height: 36px;
    bottom: 75px;
  }
  .el-form {
             margin-top: 20px;
            .el-form-item__label {
                text-align: left;
                padding-right: 0;
            }
        }
  .down {
    position: absolute;
    padding: 0;
    padding-left: 15px;
    right: 10px;
    width:92px;
    height:36px;
    box-shadow:0px 1px 10px 0px rgba(0,0,0,0.15);
    -webkit-box-shadow:0px 1px 10px 0px rgba(0,0,0,0.15);
    -ms-box-shadow:0px 1px 10px 0px rgba(0,0,0,0.15);
    -moz-box-shadow:0px 1px 10px 0px rgba(0,0,0,0.15);
    -o-box-shadow:0px 1px 10px 0px rgba(0,0,0,0.15);
    color: #fff;
    background-color:rgba(64,158,255,1);
    background-image:url("../../../common/images/gujing/excitation/icon-down.png");
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: 8px;
    background-size: 13px 12px;
  }
  .right_div {
            flex: 1;
            .p_tips {
                line-height:20px;
                color: #666;
            }
            .input {
              width: 380px;
              input {
                height: 100%;
              }
            }
            .info_warp {
                padding: 30px 0;
                padding-top: 10px;
                .info_item_div {
                    margin-top: 20px;
                    display: flex;
                    align-items: center;
                    &>span {
                        color: #333;
                        width: 70px;
                        margin-right: 10px;
                        line-height:20px;
                    }
                }
            }
            .el-button {
                width:460px;
                height:48px;
                border-radius:4px;
                border:1px solid rgba(213,217,224,1);
            }
        }
}
</style>